import { components } from "types/openapi";
import { TCommonStatus } from "./statuses";

export type CompanyEntity = components["schemas"]["CompanyDto"];
export type DefaultBankAccount = components["schemas"]["DefaultBankAccountDto"];
export type CompanyRole = components["schemas"]["CreateCompanyRequest"]["role"];
export type CreateCompanyRequest = components["schemas"]["CreateCompanyRequest"];
export type EditCompanyRequest = components["schemas"]["UpdateCompanyRequest"] & {
  initialBankBik?: string;
  correspondentAccount?: string;
  identificationDocSeria?: string;
  identificationDocNumber?: string;
  identificationDocIssuer?: string;
  identificationDocIssueDate?: string;
  identificationDocIssuerCode?: string;
  surname?: string;
  name?: string;
  patronymic?: string;
  birthDate?: string;
  postAddress?: string;
};
export type CompanyType = "COMPANY" | "IP";
export type CompanyResidentType = components["schemas"]["CompanyDto"]["isResident"];
export type UserCompanyGridDto = components["schemas"]["UserCompanyGridDto"];

export const COMPANY_TYPE_LABELS: Record<CompanyType, string> = {
  COMPANY: "Организация",
  IP: "ИП",
};

export const COMPANY_TYPES: Record<CompanyType, CompanyType> = {
  COMPANY: "COMPANY",
  IP: "IP",
};

export const COMPANY_ROLES_SELECT: Record<Exclude<CompanyRole, "OPERATOR" | "COMPANY_DOC_UPLOADING">, string> = {
  LIQUIDITY_PROVIDER: "Провайдер ликвидности",
  CUSTOMER: "Участник ВЭД",
};

export const COMPANY_ROLE_ENUM: Record<CompanyRole, CompanyRole> = {
  CUSTOMER: "CUSTOMER",
  OPERATOR: "OPERATOR",
  LIQUIDITY_PROVIDER: "LIQUIDITY_PROVIDER",
};

export const COMPANY_ROLES: TCommonStatus<CompanyRole> = {
  texts: {
    CUSTOMER: "Участник ВЭД",
    OPERATOR: "Оператор",
    LIQUIDITY_PROVIDER: "Провайдер ликвидности",
  },
  colors: {
    CUSTOMER: "blue",
    OPERATOR: "blue",
    LIQUIDITY_PROVIDER: "blue",
  },
};

export const COMPANY_ROLES_FILTERS: TCommonStatus<Exclude<CompanyRole, "COMPANY_DOC_UPLOADING">> = {
  texts: {
    CUSTOMER: "Участник ВЭД",
    OPERATOR: "Оператор",
    LIQUIDITY_PROVIDER: "Провайдер ликвидности",
  },
  colors: {
    CUSTOMER: "blue",
    OPERATOR: "blue",
    LIQUIDITY_PROVIDER: "blue",
  },
};
